export default "__VITE_ASSET__BMFE2C7R__"